<data-filter
    [filters]="dataFilters">
</data-filter>
